export class Signature{
    constructor(public r: bigInt.BigInteger, 
                public s: bigInt.BigInteger, 
                public openKey: bigInt.BigInteger){}
    getStingR():string{
        return this.r.toString(16);
    }
    getStingS():string{
        return this.s.toString(16);
    }
    getStingOpenKey():string{
        return this.openKey.toString(16);
    }

}